import { render } from "./DetailBottomBar.vue?vue&type=template&id=7d4a828a&scoped=true&ts=true"
import script from "./DetailBottomBar.vue?vue&type=script&lang=ts"
export * from "./DetailBottomBar.vue?vue&type=script&lang=ts"

import "./DetailBottomBar.vue?vue&type=style&index=0&id=7d4a828a&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4a828a"]])

export default __exports__